module.exports = __webpack_public_path__ + "static/media/icon-my-region.eaaba625.svg";